import VueRouter, { Route, RouteConfig } from "vue-router"
import authService from './servicios/authService'
import state from './state'

const contenedorCargador = () => import(/* webpackChunkName: "contenedorCargador" */ '@/shared/componentes_v2/contenidos/contenedorCargador.vue')

const routes: RouteConfig[] = [
  {
    path: '/login',
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ '@/shared/login.vue')

  },
  {
    path: "/vista/:idContenido/:idContenedor(.*)",
    name: "contenedor",
    component: contenedorCargador,
    // (Bug) Si se usa un solo param dinamico al hacer router push se agrega un %2 al url
    // Se usan 2 parametros y se asignan a prop vistaPath
    props: route => ({ vistaPath: route.params.idContenido + "/" + route.params.idContenedor, query: route.query })
  },
  {
    path: "/test",
    component: contenedorCargador,
    props: () => ({ vistaPath: "inscritos/lista" })
  },
  {
    path: '/',
    // name: 'Home',
    component:() => import(/* webpackChunkName: "home" */ "@/shared/componentes_v2/home.vue"),
    children:[
      {
        path: "busqueda/:idContenido/:idContenedor(.*)",
        component: contenedorCargador,
        // (Bug) Si se usa un solo param dinamico al hacer router push se agrega un %2 al url
        // Se usan 2 parametros y se asignan a prop vistaPath
        props: route => ({ vistaPath: route.params.idContenido + "/" + route.params.idContenedor, query: route.query })
      },
      {
        path: "/",
        redirect: process.env.VUE_APP_REDIRECT_PATH || undefined
      }
    ]
  }
]

const router: VueRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {

    //// retornar void para deshabilitar
    // return

    if (savedPosition) {
      return savedPosition
    }
    else {
      return { x: 0, y: 0 }
    }
  }
})

// GOOD
router.beforeEach((to, from, next) => {
  const isAuthenticated = authService.getToken()
  console.log({ isAuthenticated });

  if (to.name !== 'login' && !isAuthenticated) {
    // next({ name: 'login' })
    next()
  }
  else {
    next((vm: Vue & any) => {
      // vm.fromRoute = from;
      console.warn({ from });
    });
  }
})

export { router }